<div class="dynamic-container">
    <div
        class="dynamic-fields"
        [ngClass]="{
            dynamicFieldsWithoutPadding:
                fieldPair.fieldSchema.fieldType === FieldTypeEnum.GroupField
        }"
        [style.flex-basis]="fieldPair.fieldSchema.width || '100%'"
        [style.max-width]="fieldPair.fieldSchema.width || '100%'"
        *ngFor="let fieldPair of this.pairs"
    >
        <dr-review-field
            [fieldSchema]="fieldPair.fieldSchema"
            [field]="fieldPair.fieldData"
            [adminMode]="true"
        ></dr-review-field>
    </div>
</div>
